<template>
  <div class="search-tutor-list">
    <div @click.stop="" class="content">
      <div class="search">
        <div class="search-list">
          <div class="search-box">
            <div class="search-content">
              <h3 class="text-left common__search-title">Tutor</h3>
              <input type="text" v-model="conditions.tutorNameOrId">
            </div>
            <div class="search-content">
              <h3 class="text-left common__search-title">Type</h3>
              <AuthoritiesInput v-model="conditions.authorities"/>
            </div>
          </div>
          <div class="search-box">
            <div>
              <h3 class="text-left common__search-title">Position</h3>
              <PositionsInput v-model="conditions.positions"/>
            </div>
          </div>
          <div class="button-list">
            <b-button
              pill
              variant="secondary"
              @click="reset"
              class="mr-2"
            >
              Reset
            </b-button>
            <b-button
              pill
              variant="primary"
              @click="fetchTutors(page = 1)"
            >
              Search
            </b-button>
          </div>
        </div>
      </div>
      <b-table
        striped
        hover
        fixed
        Outlined
        show-empty
        :empty-text="'No data available'"
        :items="tutors"
        :fields="[
          {
            key: 'id',
            label: 'Tutor ID',
            sortable: true,
          },
          {
            key: 'name',
            label: 'Tutor Name',
          },
          {
            key: 'position',
            label: 'Position',
            /**
             * @param {Position} position
             * @return {string} ポジション名
             */
            formatter: (position) => position.name,
          },
          {
            key: 'authority',
            label: 'Type',
          },
        ]"
        :table-class="'list-table text-center'"
        :thead-class="'list-table__head'"
        :tbody-class="'list-table__body'"
        @row-clicked="selectTutor"
      >
      </b-table>

      <PagerComponent
        v-model="pager"
        @changePage="changePage"
      />
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import PagerComponent from '@/components/parts/Pager.vue';
import PositionsInput from '@/components/parts/inputItem/PositionsInput.vue';
import AuthoritiesInput from '@/components/parts/inputItem/AuthoritiesInput.vue';
import _ from 'lodash';
import { Tutor, TutorConditions } from '@/store/tutors/types';
import { RootState } from '@/store/types';
import { Pager } from '@/store/pager.types';

const initialConditions = {
  tutorNameOrId: undefined,
  positions: [],
  authorities: [],
}

@Component({
  components: {
    PagerComponent,
    PositionsInput,
    AuthoritiesInput,
  },
})
export default class ModalTutorListAllList extends Vue {
  @Prop() value!: Tutor

  private isFetchingTutors: boolean = false

  private conditions: TutorConditions = _.cloneDeep(initialConditions)

  private get tutors(): Tutor[] {
    return (this.$store.state as RootState).tutors.tutors
  }

  private get pager(): Pager {
    return (this.$store.state as RootState).tutors.pager
  }

  private get selected(): Tutor {
    return this.value
  }

  private set selected(tutor: Tutor) {
    this.$emit('input', tutor)
  }

  private created() {
    this.fetchTutors()
  }

  /**
   * テーブルからチューターを選択
   * @param {Tutor} tutor 選択されたチューター
   */
  private selectTutor(tutor: Tutor): void {
    this.selected = tutor
  }

  /**
   * チューター情報取得
   * @param {number} ページ番号
   */
  fetchTutors(page: number = 1) {
    if (this.isFetchingTutors) {
      return
    }
    this.isFetchingTutors = true

    this.$store.dispatch('fetchTutors', {
      conditions: this.conditions,
      page,
    }).finally(() => {
      this.isFetchingTutors = false
    })
  }

  /**
   * 検索条件リセット
   */
  reset(): void {
    this.conditions = _.cloneDeep(initialConditions)
    this.fetchTutors()
  }

  /**
   * ページ変更
   * @param {number} page ページ番号
   */
  changePage(page: number): void {
    this.fetchTutors(page)
  }
}
</script>

<style>
.search-tutor-list .list-table .list-table__head {
  font-size: .8rem;
}

.search-tutor-list .list-table .list-table__body td {
  font-size: .8rem;
  padding: 1rem;
}
</style>

<style scoped>

.content {
  z-index:2;
  text-align: center;
  background:#fff;
  border-radius: 10px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* 検索ボックス */
.search-list {
  background: #D8D8D8;
  padding: 20px;
  margin-bottom: 10px;
}

.search-box {
  display:flex;
  margin-bottom:20px;
}

.search-content {
  margin-right:60px;
}

.search-item {
  margin-bottom: 10px;
  text-align: left;
}

.button-list {
  display: flex;
  justify-content: flex-end;
}

input[type="text"], select{
  padding: 5px;
  border: 1px solid #AAAFB6;
  border-radius: 30px;
  width: 200px;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

input[type="checkbox"] {
  margin-right:8px;
  vertical-align: middle;
}

.checkbox {
  margin-right:40px;
}

</style>
